module.exports = __webpack_public_path__ + "static/media/Mask Group 177.ae01f240.svg";